    //this file moves the sort number to the end after the arrows to make it easier to understand the sort order
    export const AgGridCustomColumn = 
    '<div class="ag-cell-label-container" role="presentation">' +
    '	<span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button" aria-hidden="true">' +
    '	</span>' +
    '	<div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
    '		<span ref="eText" class="ag-header-cell-text">MOQ</span>' +
    '		<span ref="eFilter" class="ag-header-icon ag-header-label-icon ag-filter-icon ag-hidden" aria-hidden="true"></span>' +
    '		<!--AG-SORT-INDICATOR-->' +
    '		<span ref="eSortAsc" class="ag-sort-indicator-icon ag-sort-ascending-icon" aria-hidden="true"></span>' +
    '		<span ref="eSortDesc" class="ag-sort-indicator-icon ag-sort-descending-icon ag-hidden" aria-hidden="true"></span>' +
    '		<span ref="eSortMixed" class="ag-sort-indicator-icon ag-sort-mixed-icon ag-hidden" aria-hidden="true"></span>' +
    '		<span ref="eSortNone" class="ag-sort-indicator-icon ag-sort-none-icon ag-hidden" aria-hidden="true"></span>' +
    '		<sup><span ref="eSortOrder" class="ag-sort-indicator-icon ag-sort-order" style="padding-left: 0px" aria-hidden="true"></span></sup>' +
    '		</span>' +
    '	</div>' +
    '</div>';